// @flow
import React, { useState } from 'react';
import Slider from 'react-slick';
import { useViewport } from 'components/templates/viewportProvider';
import IconDownArrowWhite from 'assets/images/downArrowWhite.png';
import type { VirtualTour } from 'types/project';
// eslint-disable-next-line
import styles from "./styles.scss";
import Button from 'react-bootstrap/Button';

type Props = {
  tours: Array<VirtualTour>,
  onExploreClick: () => void,
};

export const VirtualToursMobile = (props: Props) => {
  const { height } = useViewport();
  const { tours } = props;
  const [viewVirtualTour, setViewVirtualTour] = useState(false);
  const mousePointers = viewVirtualTour ? 'all' : 'none';
  const virtualContainerOpacity = viewVirtualTour ? 1 : 0.3;
  if (!tours || tours.length === 0) {
    return null;
  }

  const settings = {
    className: 'slider',
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
    verticalSwiping: false,
    swipeToSlide: true,
    touchThreshold: 3000,
  };

  const onExploreClick = e => {
    setViewVirtualTour(false);
    props.onExploreClick();
  };

  return (
    <div className={'virtual-tour-mobile'} style={{ height }}>
      <h3>{`Take a 360\u00B0 tour`}</h3>
      <Slider {...settings}>
        {tours.map((tour: VirtualTour) => {
          return (
            <div className={'virtual-tour-slide'} key={tour.id}>
              {!viewVirtualTour && (
                <Button
                  variant="dark"
                  size="sm"
                  onClick={() => setViewVirtualTour(true)}
                >
                  + Click to view virtual tour
                </Button>
              )}
              <div
                className={'virtual-tour-mobile-container'}
                style={{
                  height: getVirtualTourHeight(height),
                  pointerEvents: mousePointers,
                  opacity: virtualContainerOpacity,
                }}
                dangerouslySetInnerHTML={{ __html: tour.view }}
              />
            </div>
          );
        })}
      </Slider>
      <a href={'#products'} onClick={onExploreClick} className={'explore'}>
        <img src={IconDownArrowWhite} alt={'explore'} />
      </a>
    </div>
  );
};

const getVirtualTourHeight = (height: number): number => height - 170;
